import {
  doc,
  getDocs,
  getDoc,
  collection,
  query,
  limit,
  increment,
  updateDoc,
  where,
  orderBy,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "programs", id);
};

export const getPrograms = async () => {
  const q = query(
    collection(db, "programs"),
    limit(10),
    // where("published", "==", true),
    orderBy("createdAt", "desc"),
  );
  const querySnapshot = await getDocs(q);
  const programs = querySnapshot.docs.map((doc) => {
    return { ...doc.data(), id: doc.id };
  });
  return programs;
};

export const getProgramById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const program = docSnap.data();
  if (docSnap.exists) {
    updateDoc(getDocument(id), { views: increment(1) });
    return { id: docSnap.id, ...program };
  }
};

export const getProgramsByCategory = async (category) => {
  try {
    const q = query(
      collection(db, "programs"),
      where("categories", "array-contains", category),
      // where("published", "==", true)
    );
    const docSnapshots = await getDocs(q);
    const programs = docSnapshots.docs.map((doc) => {
      return { ...doc.data(), id: doc.id };
    });

    return programs;
  } catch (error) {
    console.error(`Error while getting programs by category ${error}`);
    return error;
  }
};
